import { combineReducers } from "redux";
import {
  authorization,
  profile,
  currentRoute,
  notifications,
  app,
  usersForm,
  users,
  alerts,
  alertsForm,
  currentTheme,
  customers,
  customersForm,
  laundrys,
  laundrysForm,
  machines,
  machinesForm,
  calibrationForm,
  programsForm,
  dosificationsForm,
} from "./Reducers";

export default combineReducers({
  machines,
  machinesForm,
  calibrationForm,
  programsForm,
  dosificationsForm,
  laundrys,
  laundrysForm,
  customers,
  customersForm,
  app,
  authorization,
  currentRoute,
  profile,
  notifications,
  usersForm,
  users,
  alerts,
  alertsForm,
  currentTheme,
});
